import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { ChartDimensionState } from '@kaizenplatform/kaizen-chartjs';

export const setCoverageReportDimensionKeyState = (coverageReportDimensionKeyState: ChartDimensionState[]) =>
  produce((draft: Draft<State>) => {
    draft.coverageReportDimensionKeyState.data = coverageReportDimensionKeyState;
  });

export const disposeCoverageReportDimensionKeyState = () =>
  produce((draft: Draft<State>) => {
    draft.coverageReportDimensionKeyState.data = initialState.coverageReportDimensionKeyState.data;
  });
